// @ts-nocheck
import "lazysizes";
import VueMq from "vue-mq";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import VueMask from 'v-mask'

window._ = require("lodash");
window.axios = require("axios");
window.Vue = require("vue").default;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.prototype.svg = require("./svg");
Vue.use(VueMask);
Vue.use(VueMq, {
    breakpoints: {
        sm: 576,
        md: 769,
        lg: 1025,
        xl: 1780,
        xxl: Infinity
    },
    defaultBreakpoint: "sm"
});

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

Vue.component("section-hero-scroller", require("./sections/hero-scroller").default);
Vue.component("section-floating-cards", require("./sections/floating-cards").default);

Vue.component("job-slider", require("./parts/job-slider").default);
Vue.component("blog-slider", require("./parts/blog-slider").default);
Vue.component("team-slider", require("./parts/team-slider").default);
Vue.component("card-slider", require("./parts/card-slider").default);
Vue.component("vacancies-slider", require("./parts/vacancies-slider").default);

Vue.component("blog-filter", require("./parts/blog-filter").default);
Vue.component("blog-search-results", require("./parts/blog-search-results").default);
Vue.component("blog-spotlight", require("./parts/blog-spotlight").default);
Vue.component("vacancies-filter", require("./parts/vacancies-filter").default);
Vue.component("faq-category-spotlight", require("./parts/faq-category-spotlight").default);
Vue.component("faq-recent", require("./parts/faq-recent").default);
Vue.component("faq-categories", require("./parts/faq-categories").default);
Vue.component("faq-tools", require("./parts/faq-tools").default);
Vue.component("faq-block", require("./parts/faq-block").default);

Vue.component("plyr-video", require("./parts/video").default);
Vue.component("circles", require("./parts/circles").default);
Vue.component("floating-contact", require("./parts/floating-contact").default);
Vue.component("offices-list", require("./parts/offices-list").default);
Vue.component("quote-flaoter", require("./parts/quote-flaoter").default);
Vue.component("testimonial-flaoter", require("./parts/testimonial-flaoter").default);
Vue.component("g-map", require("./parts/g-map").default);

Vue.component("office-form", require("./forms/office-form").default);
Vue.component("job-form", require("./forms/job-form").default);
Vue.component("job-toolz-form", require("./forms/job-toolz-form").default);
Vue.component("scan-form", require("./forms/scan-form").default);
Vue.component("image-video-form", require("./forms/image-video-form").default);
Vue.component("newsletter-form", require("./forms/newsletter-form").default);
Vue.component("wp-contact-form", require("./forms/wp-contact-form").default);
Vue.component("modal-wrapper", require("./modals/modal-wrapper").default);
Vue.component("open-modal-link", require("./modals/open-modal").default);
Vue.component("template-global-notification", require("./modals/templateGlobalNotification").default);

Vue.component("hamburger-menu", require("./parts/hamburger-menu").default);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(require("vue-moment"));

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDgdGCT5tePIoKXitcT8D7bu98NGgmrukU",
        libraries: "places"
    }
});

import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VClamp from "vue-clamp";

new Vue({
    el: "#app",
    components: {
        VueGoodshareFacebook,
        VueGoodshareTwitter,
        VueGoodshareLinkedIn,
        VClamp
    },
    mounted() {
        const l: number = document.querySelector(".container").offsetLeft;
        document.querySelectorAll(".container-right").forEach(element => {
            element.style.right = `${l}px`;
        });
    }
});
